import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { MomentModule } from 'ngx-moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ViewDailyTransactionsComponent } from './view-daily-transactions.component';
import { ViewTransactionsComponent } from './view-transaction.component';
import { ViewSettlementDetailsComponent } from './view-settlement-details.component';
import { TransactionAttachemntComponent } from '../transactions/attachments/attachment.component';
import { SettlementCommentsComponent } from '../settlements/comments/comments.component';
import { SettlementAttachmentsComponent } from '../settlements/attachments/attachments.component';
import { TransactionCommentsComponent } from '../transactions/comments/comments.component';
import { ViewSettledTransactionsComponent } from './view-settled-transactions.component';
import { ViewOrdersComponent } from './view-orders.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzAvatarModule, NzCommentModule, NzDatePickerModule, NzDividerModule, NzInputNumberModule, NzListModule, NzSelectModule } from '../utilities/ng-zorro-antd.module';

@NgModule({
    declarations: [
        ViewDailyTransactionsComponent,
        ViewTransactionsComponent,
        ViewSettlementDetailsComponent,
        TransactionCommentsComponent,
        TransactionAttachemntComponent,
        SettlementCommentsComponent,
        SettlementAttachmentsComponent,
        ViewSettledTransactionsComponent,
        ViewOrdersComponent
    ],
    imports: [
        CommonModule,
        NzLayoutModule,
        NzGridModule,
        NzMenuModule,
        NzIconModule,
        NzButtonModule,
        NzDrawerModule,
        NzModalModule,
        NzNotificationModule,
        NzTableModule,
        NzFormModule,
        NzInputModule,
        NzUploadModule,
        FormsModule,
        MomentModule,
        ReactiveFormsModule,
        NzSpinModule,
        NzTabsModule,
        NzTagModule,
        NzToolTipModule,
        NzPaginationModule,
        NzListModule,
        NzSelectModule,
        NzDividerModule,
        NzInputNumberModule,
        NzDatePickerModule,
        NzCommentModule,
        NzAvatarModule
    ],
    exports: [
        TransactionCommentsComponent,
        TransactionAttachemntComponent,
        SettlementCommentsComponent,
        SettlementAttachmentsComponent,
        ViewSettledTransactionsComponent,
        ViewOrdersComponent
    ]
})
export class ViewDetailsModule {
  static forRoot() {
    return {
      ngModule: ViewDetailsModule,
      providers: [],
    };
  }
}
